<template>
  <div class="f360-callout">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.f360-callout {
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 0 1rem 0;
  background-color: #f0f7fd;
  border-left: 5px solid #d0e3f0;
  font-family: "Plus Jakarta Sans", sans-serif;
  margin: 10px 0;

  p {
    font-size: 14px;
    color: #2e2e2e;
  }
}
</style>
